var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createReducer } from '@reduxjs/toolkit';
var initialState = null;
export default createReducer(initialState, {
    'invite/getWorkspaceName': function (state, action) {
        return __assign(__assign({}, state), action.payload);
    },
    'invites/fetchDetails/fulfilled': function (_, action) {
        return action.payload;
    },
    'user/rejectInvite/fulfilled': function (state, action) {
        var workspaceId = action.payload;
        var _a = __assign({}, state), _b = workspaceId, omit = _a[_b], invites = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return invites;
    },
    'auth/signOut': function () { return initialState; },
});
